// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__hQxt-","notes":"Notes_notes__vYZhL","note":"Notes_note__2jwK4","markdown":"Notes_markdown__29JB3"};